//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'SolitaryNodule',
  data () {
    return {
      defaultJson:{
        "Current or Former Smoker": "吸烟史",
        "No study": "无影像",
        "Moderate": "中度",
        "Risk of Malignancy": "恶性肿瘤风险",
        "Diameter": "直径",
        "Upper Lobe": "上叶",
        "Intense": "高度",
        "Faint": "少量",
        "Intense uptake": "高度摄取",
        "No uptake": "无摄取",
        "No PET study": "无 PET 影像",
        "Spiculated Edge": "边缘毛刺样",
        "Extrathoracic Cancer": "胸外恶性肿瘤",
        "None": "无",
        "Age": "年龄",
        "FDG Uptake": "FDG 摄取",
        "Faint uptake": "少量摄取",
        "Moderate uptake": "中度摄取"
      },
      form: {
        age:'',
        diam:'',
        pFDGuptake:'',
        pSmokingHx:'0',
        pExtraThoracicCancer:'0',
        pSpiculatedEdge:'0',
        pUpperLobe:'0',
      },
      dataList1: [
        {value: '-1"', name: '无 PET 影像',shortName:'无影像'},
        {value: '0', name: '无摄取',shortName:'无'},
        {value: '2.322', name: '少量摄取',shortName:'少量'},
        {value: '4.617', name: '中度摄取',shortName:'中度'},
        {value: '4.771', name: '高度摄取',shortName:'高度'},
      ],
      hasScore: false,
      disabled: false,
      descTxt:'',
      x:'--',
      res:'--',
      y:'--',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // - 6.8272 + (0.0391*age) + (pSmokingHx ? 0.7917 : 0) + (pExtraThoracicCancer ? 1.3388 : 0) + (0.1274*diam) + (pSpiculatedEdge ? 1.0407 : 0) + (pUpperLobe ? 0.7838 : 0)
        let x = - 6.8272 + (0.0391*form.age) + (form.pSmokingHx ? 0.7917 : 0) + (form.pExtraThoracicCancer ? 1.3388 : 0) + (0.1274*form.diam) + (form.pSpiculatedEdge ? 1.0407 : 0) + (form.pUpperLobe ? 0.7838 : 0)
        let res = 	1 / (1 + Math.pow(Math.E,(-x)))
        let y = 	form.pFDGuptake >=0 ?	(-4.739 + (3.691*res) + form.pFDGuptake) :	(x)



        //  form.
        let result =	100 / (1 + Math.pow(Math.E, (-y)))
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/SolitaryNodule.vue